<template>
  <div class="container">
    <h2 class="mb-5">Input Overview</h2>
    <form
      name="test"
      style="margin: 0 auto; max-width: 700px;"
      @submit.prevent="onSubmit"
    >
      <base-text
        name="company"
        label="Company"
        v-model="base.company.name"
        :disabled="true"
      ></base-text>
      <base-text
        name="country"
        label="Country of collection"
        v-model="base.country.name"
        :disabled="true"
      ></base-text>
      <base-text
        name="month"
        label="Month of processing"
        v-model="base.collection_date"
        :disabled="true"
      ></base-text>
      <base-text
        name="material"
        label="Material"
        :value="materialName"
        :disabled="true"
      ></base-text>

      <div class="row mt-4">
        <div class="col-6 text-left">
          <base-button
            radius="bl"
            component-class="blue"
            @click.native="$router.go(-1)"
          >
            <i class="fas fa-arrow-left mr-3"></i> Previous
          </base-button>
        </div>
        <div class="col-6 text-right">
            <base-button
            radius="br"
            component-class="green filled"
            type="submit"
            >Save <i class="fas fa-arrow-right ml-3"></i>
            </base-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import BaseText from '@/components/inputs/text/BaseText';
  import BaseButton from '@/components/inputs/button/BaseButton';

  export default {
    data() {
      return {
        base: {
          company: { name: '' },
          country: { name: '' },
          collection_date: '',
          material: { name: '' },
        },
        inputSecond: {
          prePostConsumer: 'post-c',
          volumeGross: null,
          volumeNet: null,
          contamination: null,
        }
      };
    },
    computed: {
      ...mapState({
        baseData: state => state.submitWaste.baseData,
        inputSecondData: state => state.submitWaste.inputSecondData,
        lastCompositionInput: state => state.submitWaste.lastCompositionInput,
      }),
      materialName() {
        const { name } = this.lastCompositionInput;
        if (name) {
          return name;
        }
        return `${this.base.material.name} ${this.inputSecond.prePostConsumer}`;
      }
    },
    methods: {
      async onSubmit () {
        this.$store.dispatch('submitWaste/saveWizardInput', this.$router).then(() => {
          // this.$router.push({name: 'user.dashboard'});
          // this.$snotify.success('Submission saved.');
        });

        // const { company, country, collection_date, material } = this.base;
        // const { prePostConsumer, volumeGross, volumeNet, contamination } = this.inputSecond;

        // console.log({
        //   company, country, collection_date, material,
        //   prePostConsumer, volumeGross, volumeNet, contamination
        // });
      },
    },

    async mounted () {
      this.base = this.baseData;
      this.inputSecond = this.inputSecondData;

      const { name } = this.lastCompositionInput;

      if (name) {
        this.base.material.name = name;
      }

      // if (createdAt) {
        // this.base.collection_date = moment(moment(createdAt), 'MM-YYYY').format('MM-YYYY');;
      // }
    },

    components: {
      'base-text': BaseText,
      'base-button': BaseButton,
    }
  };

</script>
